var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.943,
    height: 16.267,
    viewBox: "0 0 13.943 16.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 533",
    d: "m28.309 24.317-.822-.822-1.5 1.5V20.25h-1.163V25l-1.5-1.5-.822.821 2.9 2.9z",
    transform: "translate(-14.367 -10.955)",
    style: {
      fill: "#6f52f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 534",
    d: "M13.721 17.354H7.912V3.412h4.648V6.9a1.166 1.166 0 0 0 1.162 1.162h3.486V9.8h1.162V6.9a.529.529 0 0 0-.174-.406l-4.068-4.07a.528.528 0 0 0-.407-.175H7.912A1.166 1.166 0 0 0 6.75 3.412v13.942a1.165 1.165 0 0 0 1.162 1.162h5.809zm0-13.71L16.975 6.9h-3.254z",
    transform: "translate(-6.75 -2.25)",
    style: {
      fill: "#6f52f7"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDownload);
export default __webpack_public_path__ + "static/media/document-download.566cba7956f651df9c32894285768015.svg";
export { ForwardRef as ReactComponent };